<main class="email-form p-3 ri-w-600">
    <!-- <div class="d-flex justify-content-between mb-3">
        <h6 class="fw-semibold mb-0">Email {{ mode === 'new' ? 'Create' : 'Update' }}</h6>
    </div> -->

    <div class="ri-dialog-content" [ngClass]="{ 'ri-pe-none': emailInitial.deletedAt }">
        <form [formGroup]="emailForm" #emForm="ngForm">
            <mat-form-field appearance="fill" class="w-100 mb-1"
                [class]="{ 'edited' : emailForm.value.templateName !== emailInitial.templateName }">
                <mat-label>Template Name</mat-label>
                <input matInput type="text" [readonly]="mode === 'edit'" autocomplete="off" autocorrect="off"
                    autocapitalize="none" spellcheck="false" formControlName="templateName" name="riEmailTemplateName"
                    noSpaces />
            </mat-form-field>

            <app-select [options]="languages" label="displayName" value="code" [title]="'Default Language'"
                class="w-100 d-block mb-1" [control]="getFc('defaultLangCode')"
                [defaultValue]="emailInitial.defaultLangCode" [disabled]="mode === 'edit'"></app-select>

            <mat-form-field appearance="fill" class="w-100 mb-1"
                [class]="{'edited' : emailForm.value.description !== emailInitial.description}">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" name="riTodoDescription" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"></textarea>
            </mat-form-field>
        </form>
    </div>

    <div class="ri-dialog-footer" [ngClass]="{'ri-pe-none': emailInitial.deletedAt}">
        <div class="d-flex justify-content-between mt-5" *ngIf="!emailInitial.deletedAt">
            <div class="d-flex">
                <button *ngIf="mode === 'edit'" type="button" class="btn btn-sm text-bg-danger me-2"
                    (click)="deleteHandler(true)" [disabled]="emailInitial.deletedAt" matTooltip="Delete">
                    Delete
                </button>
                <button class="btn btn-sm btn-info" *ngIf="mode === 'edit' && !data.hideEditButton"
                    [routerLink]="['/email-editor', emailInitial.id]" (click)="closeDialog()">Edit Template</button>
            </div>
            <div>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="reset()"
                    [disabled]="!hasChanges()">Reset</button>
                <button type="submit" class="btn btn-sm btn-primary ms-2" (click)="save()"
                    [disabled]="!hasChanges() || emailForm.invalid">Save</button>
            </div>
        </div>
    </div>

</main>
